import React, { useEffect, useState } from 'react'
import { Alert, Card, Col, Container, Row, Spinner } from 'react-bootstrap'
import ConfigLayout from '../../Layouts/ConfigLayout'
import qs from 'qs'
import { useDispatch, useSelector } from 'react-redux'
import { verifyUser } from '../../../redux/actions/user'
import { useHistory } from 'react-router-dom'

const Verify = () => {
  const [show, setShow] = useState(false)

  const dispatch = useDispatch()
  const verifyUserState = useSelector((state) => state.user.verifyUser)

  const history = useHistory()

  useEffect(() => {
    const querystring = qs.parse(window.location.search.slice(1))

    if(typeof querystring.user === 'undefined') {
      setShow(true)
    } else {
      dispatch(verifyUser(querystring.user))
    }
  }, [])

  useEffect(() => {
    if (verifyUserState.success) {
      history.push('/change-password')
    }

    if (verifyUserState.error !== false) {
      setShow(true)
    }

  }, [verifyUserState.success, verifyUserState.error])

  return (
    <ConfigLayout showUser={false}>
      <Container fluid className='font-85'>
        <Row>
          <Col xs={12}>
            <Col xs={12} className='mb-3'>
              <Card className='auth-container mx-auto'>
                <Card.Body>
                  <Row>
                    <Col xs={12} className='mb-3'>
                      <Alert variant='danger' dismissible show={show} onClose={() => setShow(false)}>
                        Unable to verify user.
                      </Alert>
                      <div className='text-center'>
                        {
                          verifyUserState.loading ? (
                            <Spinner animation="border" role="status">
                              <span className="sr-only">Loading...</span>
                            </Spinner>
                          ) : null
                        }
                      </div>
                    </Col>
                    <Col xs={12}>
                        Need Help? Send email to: <u><a href='mailto:lupusadvisor@pocp.com' className='text-muted'>lupusadvisor@pocp.com</a></u>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
            <Col xs={12} className='text-center mb-3'>
              <h4>
                <u><a className='text-muted' href='https://info.pocp.com/lupus_advisor' target='_blank' rel='noreferrer'>About Lupus Advisor</a></u>
              </h4>
            </Col>
            <Col xs={12} className='text-center'>
              <div className='text-muted'>
              Lupus Advisor Configurator is available to current customers of Lupus Advisor.
              </div>
            </Col>
          </Col>
        </Row>
      </Container>
    </ConfigLayout>
  )
}

export default Verify
